/**
 * Центр уведомлений (колокольчик, /notifications) не включает чатовые типы —
 * они учитываются в разделе «Чат» (badge по комнатам). Push по новым сообщениям
 * в чате по-прежнему уходит с сервера (create_notification), отдельно от ленты.
 */
export const NOTIFICATION_CENTER_EXCLUDES_CHAT = true;
